import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lead-details',
  templateUrl: './lead-details.component.html',
  styleUrls: ['./lead-details.component.css']
})
export class LeadDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
